module.exports = __webpack_public_path__ + "media/images/about-trainer_profile_pisco@2x-90ba1dc732f69ee98dd32d4603543989.jpg";